module.exports = __webpack_public_path__ + "popup-bg.jpg?94396815b34aea638dde21b9d09e9b0a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/popup-bg.jpg
// module id = 66
// module chunks = 0